import React, { use } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { hideSnackbar } from '../store/slices/snackbarSlice';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SuccessSnackbar = () => {
    const dispatch = useDispatch();
    const { message, open, type } = useSelector((state: any) => ({
        message: state?.snackbar?.message,
        open: state?.snackbar?.open,
        type: state?.snackbar?.type,
    }));
    const handleClose = () => {
        dispatch(hideSnackbar());
    };
    return (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
            <Alert onClose={handleClose} severity={type}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export default SuccessSnackbar;